import { useSearchParams } from 'react-router-dom';

/** Keep the selected section in shareable URLs and browser Back/Forward history. */
export function useDetailSection<T extends string>(sections: readonly { id: T }[], fallback: T) {
  const [params, setParams] = useSearchParams();
  const requested = params.get('section') ?? params.get('tab');
  const active = sections.find(section => section.id === requested)?.id ?? fallback;
  const select = (id: T) => setParams(previous => {
    const next = new URLSearchParams(previous);
    next.set('section', id);
    return next;
  });
  return [active, select] as const;
}
